import type { ConsentFormDto } from "@/shared/edge/queries";

/** The forms every patient signs before the portal opens. Others are offered afterwards. */
export const coreConsentForms = (forms: ConsentFormDto[]) => forms.filter((form) => form.core);

/** Core forms are signed in order: the first unsigned one is the only one open. */
export const nextUnsignedConsent = (forms: ConsentFormDto[]) => coreConsentForms(forms).find((form) => !form.signed);
